<script>
  import {
    formatTimeDelta,
    formatPercentage,
  } from "lib/util/formatfunctions.js";
  import { pmfilters } from "lib/stores.js";
  import { getApplicableFilters } from "../../../../../lib/util/getApplicableFilters";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";

  import { Accordion } from "paxray-components-svelte";
  import SideKpi from "lib/components/sideKPI.svelte";

  export let analysisid;
  export let currentActivity = "";

  let kpis = {
    activityCount: 0,
    caseCount: 0,
    executionTimeLong: 0,
    executionTimeMax: 0,
    executionTimeMean: 0,
    executionTimeMedian: 0,
    executionTimeMin: 0,
    executionTimeStd: 0,
    handovers: 0,
    lastActivity: "",
    longestActivity: "",
    reworkCount: 0,
    stepsLong: 0,
    stepsMax: 0,
    stepsMean: 0,
    stepsMedian: 0,
    stepsMin: 0,
    stepsStd: 0,
    uniqueActivities: 0,
  };
  let variantCounts = [{ data: [] }];
  let activitykpis = {};

  $: applicableFilters = getApplicableFilters($pmfilters[analysisid]);
  $: filterString = JSON.stringify(applicableFilters);

  $: {
    fetchWithSession(
      `/api/analysis/cases/getKPI/${analysisid}?filter=${filterString}`
    )
      .then((response) => response.json())
      .then((data) => {
        kpis = data;
      });
  }
  $: {
    fetchWithSession(
      `/api/analysis/cases/getVariantCounts/${analysisid}?filter=${filterString}`
    )
      .then((response) => response.json())
      .then((data) => {
        variantCounts = data;
      });
  }

  $: {
    if (currentActivity != "") {
      fetchWithSession(
        `/api/analysis/cases/getKPI/${analysisid}/${currentActivity}?filter=${filterString}`
      )
        .then((response) => response.json())
        .then((data) => {
          activitykpis = data;
        });
    }
  }
</script>

<div class="menu">
  <Accordion heading="Process KPIs" open={!currentActivity}>
    <div class="side_kpis">
      <SideKpi name="Cases" value={kpis["caseCount"]} />
      <SideKpi name="Activities" value={kpis["activityCount"]} />
      <SideKpi name="Variants" value={variantCounts[0]["data"].length} />
      <SideKpi
        name="Rework Cases"
        value={kpis["reworkCount"] +
          " (" +
          formatPercentage(
            kpis["reworkCount"] / kpis["caseCount"]
              ? kpis["reworkCount"] / kpis["caseCount"]
              : 0
          ) +
          ")"}
      />
      <SideKpi name="Unique Activites" value={kpis["uniqueActivities"]} />
      <SideKpi name="Handovers" value={Math.round(kpis["handovers"], 2)} />
      <SideKpi name="Longest Activity" value={kpis["longestActivity"]} />
      <SideKpi name="Current Bottleneck" value={kpis["lastActivity"]} />
    </div>
  </Accordion>
  <Accordion heading="Activity Information" open={currentActivity}>
    <div class="side_kpis">
      <SideKpi name="Activity" value={currentActivity} />
      <SideKpi
        name="Execution Frequency"
        value={currentActivity ? activitykpis["executionFrequency"] : ""}
      />
      <SideKpi
        name="Average Execution Time"
        value={currentActivity
          ? formatTimeDelta(activitykpis["averageExecutionTime"])
          : ""}
      />
      <SideKpi
        name="Case Coverage"
        value={currentActivity
          ? formatPercentage(activitykpis["caseCoverage"])
          : ""}
      />
    </div>
  </Accordion>
  <Accordion heading="Execution Time" open={false}>
    <div class="side_kpis">
      <SideKpi name="Min" value={formatTimeDelta(kpis["executionTimeMin"])} />
      <SideKpi name="Max" value={formatTimeDelta(kpis["executionTimeMax"])} />
      <SideKpi
        name="Median"
        value={formatTimeDelta(kpis["executionTimeMedian"])}
      />
      <SideKpi name="Mean" value={formatTimeDelta(kpis["executionTimeMean"])} />
      <SideKpi name="Std" value={formatTimeDelta(kpis["executionTimeStd"])} />
      <SideKpi
        name="Time-Consuming Activities"
        value={kpis["executionTimeLong"] +
          " (" +
          formatPercentage(
            kpis["executionTimeLong"] / kpis["caseCount"]
              ? kpis["executionTimeLong"] / kpis["caseCount"]
              : 0
          ) +
          ")"}
      />
    </div>
  </Accordion>
  <Accordion heading="Process Steps" open={false}>
    <div class="side_kpis">
      <SideKpi name="Min" value={kpis["stepsMin"]} />
      <SideKpi name="Max" value={kpis["stepsMax"]} />
      <SideKpi name="Median" value={kpis["stepsMedian"]} />
      <SideKpi name="Mean" value={kpis["stepsMean"]} />
      <SideKpi name="Std" value={kpis["stepsStd"]} />
      <SideKpi
        name="Long Cases"
        value={kpis["stepsLong"] +
          " (" +
          formatPercentage(
            kpis["stepsLong"] / kpis["caseCount"]
              ? kpis["stepsLong"] / kpis["caseCount"]
              : 0
          ) +
          ")"}
      />
    </div>
  </Accordion>
</div>

<style>
  .menu {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: calc(100vh - 6rem);
    overflow-x: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .side_kpis {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
